exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".titulo{color:#352da5}.complete-filter .input-with-date,.complete-filter .input-with-date input{width:100%}.complete-filter button{margin-top:10px;width:200px;padding:0 20px;margin-left:5px}.price-value{display:block;margin-bottom:20px;font-weight:600;text-transform:capitalize;color:#444d58;font-size:16px;margin-left:6px;margin-top:0}.price-value span{color:#e7505a}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-8ff7a13e","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/vue/pages/restricted/allCompany/RegisterCompany.vue
// module id = 1186
// module chunks = 0